import {
    Button,
    ButtonVariants,
    Icon,
    IconNames,
    MessageBlock,
    MessageBlockType,
} from "@triumph/design-system";
import { Trans, useTranslation } from "react-i18next";
import {
    HeaderCenter,
    CenterParagraph,
    HeaderWrapper,
    HeaderRow,
    HeaderSubmittedLeft,
    HeaderLeft,
    CommonParagraph,
} from "./BillingReminderHeader.StyledComponents";
import { useAppContext } from "@/app/components/providers/AppContextProvider";
import { getInvoicesPastDueCSV } from "@/app/shared/api/endpoints/invoicePastDue";
import { getInvoicesAllCSV } from "@/app/shared/api/endpoints/invoicesAll";
import {
    ButtonsWrapper,
    ExportButton,
    SchedulePaymentButton,
} from "../PendingInvoicesTable/PendingInvoices.StyledComponents";

interface BillingReminderHeaderProps {
  isSubmitted: boolean;
  paymentLinkUrl: string;
  invoicesSubmitted: number;
  showUnableToSubmitMessage: boolean;
}

export const BillingReminderHeader = ({
  isSubmitted,
  paymentLinkUrl,
  invoicesSubmitted,
  showUnableToSubmitMessage
}: BillingReminderHeaderProps) => {
  const { t } = useTranslation("billingReminder");
  const { theme } = useAppContext();

  return (
    <div>
      {isSubmitted ? (
        <div>
          <HeaderCenter>{t("submission.thankYou")}</HeaderCenter>
          <CenterParagraph>
            <Icon
              color={theme.colors.semantic.successDefault}
              name={IconNames.Success_Filled}
              id={"success-check-icon"}
            />
            {`You have successfully submitted updates for ${invoicesSubmitted} invoices. Export List to see submitted invoices.`}
          </CenterParagraph>
          <HeaderWrapper>
            <HeaderRow>
              <HeaderSubmittedLeft>{t("header.title")}</HeaderSubmittedLeft>
              <ButtonsWrapper>
                <ExportButton>
                  <Button
                    variant={ButtonVariants.tertiary}
                    icon={IconNames.Interface_Download}
                    id={"csv-icon"}
                    iconLeft={true}
                    onClick={getInvoicesAllCSV}
                  >
                    Export List
                  </Button>
                </ExportButton>
                {paymentLinkUrl ? (
                  <SchedulePaymentButton>
                    <a
                      target="_blank"
                      href={paymentLinkUrl}
                      rel="noopener noreferrer"
                    >
                      <Button
                        icon={IconNames.Interface_Expand}
                        iconRight={true}
                        id={"payment-link-icon"}
                      >
                        {t("header.schedulePayment")}
                      </Button>
                    </a>
                  </SchedulePaymentButton>
                ) : null}
              </ButtonsWrapper>
            </HeaderRow>
          </HeaderWrapper>
        </div>
      ) : (
        <HeaderWrapper>
          <HeaderRow>
            <HeaderLeft>{t("header.title")}</HeaderLeft>
            </HeaderRow>
            {showUnableToSubmitMessage ?
                <CommonParagraph>
                    <MessageBlock show={showUnableToSubmitMessage} breakpoint={"120px"} message={t("header.error")} type={MessageBlockType.error} messageId={0} width='auto' />
                </CommonParagraph>
                : null
            }
            <HeaderRow>
                <CommonParagraph>
                    <Trans
                        ns="billingReminder"
                        i18nKey="header.subTitle"
                        components={{
                            bold: <b></b>,
                            break: <br />
                        }}
                    />
                </CommonParagraph>
            <ButtonsWrapper>
              <ExportButton>
                <Button
                  variant={ButtonVariants.tertiary}
                  icon={IconNames.Interface_Download}
                  id={"csv-icon"}
                  iconLeft={true}
                  onClick={() => {
                    getInvoicesPastDueCSV();
                  }}
                >
                  Export List
                </Button>
              </ExportButton>
              {paymentLinkUrl ? (
                <SchedulePaymentButton>
                  <a
                    target="_blank"
                    href={paymentLinkUrl}
                    rel="noopener noreferrer"
                  >
                    <Button
                        icon={IconNames.Interface_Expand}
                        iconRight={true}
                        id={"payment-link-icon"}
                    >
                        {t("header.schedulePayment")}
                    </Button>
                  </a>
                </SchedulePaymentButton>
              ) : null}
            </ButtonsWrapper>
          </HeaderRow>
        </HeaderWrapper>
      )}
    </div>
  );
};
